import { LoadingKey } from '../app-active-loading/LoadingKey';
import { isEmailVerificationSignupAndNotPostVerification, isntExistingUserExistingAccount, isntGoogleSignup } from '../app/verificationTypeSelectors';
import SignupClient from '../http-clients/SignupClient';
import { handleCompleteVerificationError } from '../http-complete-verification/handleCompleteVerificationError';
import { handleCompleteVerificationResponse } from '../http-complete-verification/handleCompleteVerificationResponse';
import { handleCompleteVerificationSuccess } from '../http-complete-verification/handleCompleteVerificationSuccess';
import { handleInitiateVerificationError, handleInitiateVerificationSuccess } from '../http-initiate-verification/handleInitiateVerificationResponse';
import { handleSignupError } from '../http-signup/handleSignupError';
import { handleSignupResponse } from '../http-signup/handleSignupResponse';
import { handleSignupSuccess } from '../http-signup/handleSignupSuccess';
import { generateRecaptchaToken } from '../recaptcha/utils/generateRecaptchaToken';
import { Data } from '../signup-data/DATA';
import { handleCodeVerificationError } from '../step-code-verification/handleCodeVerificationError';
import { handleCodeVerificationSuccess } from '../step-code-verification/handleCodeVerificationSuccess';
import { FlowActionTypes } from '../store/flow/action-types';
import { getPreVerificationDataKeys } from '../store/signup-data/selectors';
import { CodeVerificationActionTypes } from '../store/step-code-verification/action-types';
import { Step } from '../views/Step';
import { addRequiredVerificationData } from './addRequiredVerificationData';
import { EndpointKey } from './EndpointKey';
import { shouldRequirePassword } from './shouldRequirePassword';
export const EndpointsSignupClient = {
  [EndpointKey.InitiateVerification]: {
    getRequestData: state => getPreVerificationDataKeys(state),
    stateCheck: isEmailVerificationSignupAndNotPostVerification,
    handleError: handleInitiateVerificationError,
    handleSuccess: (_, dispatch) => handleInitiateVerificationSuccess(dispatch),
    loadingKey: LoadingKey.InitiateVerificationRequest,
    method: SignupClient.initiateVerification,
    nextStep: [Step.Verification, Step.CodeVerification]
  },
  [EndpointKey.CompleteVerification]: {
    getRequestData: () => [Data.Token, Data.Email],
    handleResponse: handleCompleteVerificationResponse,
    handleError: handleCompleteVerificationError,
    handleSuccess: handleCompleteVerificationSuccess,
    loadingKey: LoadingKey.CompleteVerificationRequest,
    method: SignupClient.completeVerification,
    stateCheck: isntGoogleSignup,
    once: true
  },
  [EndpointKey.CompleteVerificationByCode]: {
    getRequestData: () => [Data.CodeVerification, Data.Email],
    handleError: handleCodeVerificationError,
    handleSuccess: handleCodeVerificationSuccess,
    method: SignupClient.completeVerification,
    reduxActionType: CodeVerificationActionTypes.Start,
    stateCheck: isntGoogleSignup
  },
  [EndpointKey.Signup]: {
    stateCheck: isntExistingUserExistingAccount,
    getRequestData: state => {
      return [...getPreVerificationDataKeys(state), ...addRequiredVerificationData(state), ...(shouldRequirePassword(state) ? [Data.Password] : [])];
    },
    handleError: handleSignupError,
    handleSuccess: handleSignupSuccess,
    handleResponse: handleSignupResponse,
    loadingKey: LoadingKey.SignupRequest,
    reduxActionType: FlowActionTypes.FinishSignup,
    method: SignupClient.signup,
    onBefore: dispatch => dispatch(generateRecaptchaToken('before_finish_signup'))
  }
};